import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

// Layout
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";

// Pages
import HomePage from "./pages/HomePage";
import ShowsPage from "./pages/ShowsPage";
import ShowDetailPage from "./pages/ShowDetailPage";
import TourDatesPage from "./pages/TourDatesPage";
import HistoryPage from "./pages/HistoryPage";
import NewsPage from "./pages/NewsPage";
import NewsDetailPage from "./pages/NewsDetailPage";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import MediaPage from "./pages/MediaPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import LoginPage from "./pages/LoginPage";
import AdminDashboard from "./pages/AdminDashboard";
import MediaLoginPage from "./pages/MediaLoginPage";
import MediaPortalPage from "./pages/MediaPortalPage";

import "./App.css";

function App() {
  // Get basename from PUBLIC_URL for subdirectory deployment
  const basename = process.env.PUBLIC_URL || '';
  
  return (
    <div className="App min-h-screen bg-brand-dark">
      <BrowserRouter basename={basename}>
        <ScrollToTop />
        <Routes>
          {/* Admin routes without Layout */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/media-login" element={<MediaLoginPage />} />
          <Route path="/media-portal" element={<MediaPortalPage />} />
          
          {/* Public routes with Layout */}
          <Route path="/*" element={
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shows" element={<ShowsPage />} />
                <Route path="/shows/:showId" element={<ShowDetailPage />} />
                <Route path="/tour-dates" element={<TourDatesPage />} />
                <Route path="/media" element={<MediaPage />} />
                <Route path="/history" element={<HistoryPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/news/:articleId" element={<NewsDetailPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
              </Routes>
            </Layout>
          } />
        </Routes>
      </BrowserRouter>
      <Toaster 
        position="bottom-right" 
        theme="dark"
        toastOptions={{
          style: {
            background: '#08065E',
            border: '1px solid rgba(255,255,255,0.1)',
            color: '#F8FAFC'
          }
        }}
      />
    </div>
  );
}

export default App;
